<template>
    <div class="page-wrapper flex flex-direction page-wrapper bg-white radius-lg padding margin-left-sm flex-sub">
        <el-empty v-if="lists.length === 0"/>
        <div class="flex flex-direction">
            <div v-for="(item,index) in lists" :key="index" class="item-notice flex align-center justify-between" @click="showDetail(item.id)">
                <div class="title">{{ item.title }}</div>
                <div class="time">{{ item.create_time }}</div>
            </div>
        </div>
        <el-pagination
            v-if="lists.length>0"
            :current-page.sync="page"
            :page-size="limit"
            :total="total"
            background
            class="page-all margin-top self-end"
            layout="prev, pager, next, jumper"
            @current-change="init">
        </el-pagination>
        <version-detail-dialog :detailDialogVisible="detailDialogVisible" :nid="cur_nid"
                               @watchState="watchState"></version-detail-dialog>
    </div>
</template>

<script>
import VersionDetailDialog from "@/views/web/components/VersionDetailDialog";
import {zhDate} from "@/utils/utils";
import {getVersionList} from "@/api";

export default {
    name: "version",
    components: {
        VersionDetailDialog,
    },
    data() {
        return {
            lists: [],
            page: 1,
            limit: 10,
            total: 0,

            cur_nid: 0,
            detailDialogVisible: false,
        }
    },
    created() {
        this.$emit('setIndex', [], '版本更新', true)
        this.init()
    },
    computed: {},
    methods: {
        async init() {
            let _data = await getVersionList(this.page, this.limit)
            console.log(_data.data)
            _data.data.data.map(item => {
                item.create_time = zhDate(item.create_time * 1000)
            })
            this.lists = _data.data.data
            this.total = _data.data.total
        },
        showDetail(id) {
            this.cur_nid = id
            this.detailDialogVisible = true;
        },
        watchState() {
            this.detailDialogVisible = false;
        },
    }

}
</script>

<style lang="scss" scoped>
.page-wrapper {

    .item-notice {
        width: 100%;
        height: 70px;
        cursor: pointer;

        .title {
            font-size: 20px;
            font-weight: bold;
            color: #0a2240;
        }

        .time {
            font-size: 16px;
            color: #666666;
        }

        border-bottom: 1px solid #eeeeee;
    }

}
</style>